import React , { useState , useEffect } from 'react'


import { ApiCallGet } from '../ApiCall/ApiCall'


import { useNavigate , useLocation } from "react-router-dom";


import { Form , Row , Col} from 'react-bootstrap'

// Se nos pasa el id del caso cuenta
export default function ConfigCuentasDetail( ) {

    const [data,setData] = useState(null)


    //const navigate = useNavigate();

    const location = useLocation() ;



    useEffect(() => {


        console.log( "iscasocuenta = "  , location.state.id  )


        // getcuentadetail

        ApiCallGet( "getcuentadetail/?cuenta=" + location.state.id )
        .then((response) =>{
            console.log( "getcuentadetail = " , response  )

            setData( response ) ;
        
        })
        .catch((err) =>{
            console.log( err ) ;

        })



    } , [])

  return (
    <>
        <Form className='pt-0 ps-5 pe-3 form-2 w-100 mt-3' style={{marginLeft:'150' ,
            backgroundColor :'lightgray' , borderRadius :'10px'}} >

        <h4 className='pt-3'>Cuenta {location.state.id}</h4>

        <Row>
            <Col className='col-3' >
                <p>Clave Producto Servicio</p>
            </Col>

            <Col className='col-6' >
                {
                    data !== null && (
                        <p>{data.claveproductoserv}</p>
                    )
                }
                
            </Col>
        </Row>

        <Row>
            <Col className='col-3' >
                <p>Uso Cfdi</p>
            </Col>

            <Col className='col-6' >
                {
                    data !== null && (
                        <p>{data.usoCfdi}</p>
                    )
                }
                
            </Col>
        </Row>

        <Row>
            <Col className='col-3' >
                <p>Filtro Campo</p>
            </Col>

            <Col className='col-6' >
                {
                    data !== null && (
                        <p>{data.filtro_campo}</p>
                    )
                }
                
            </Col>
        </Row>


        <Row>
            <Col className='col-3' >
                <p>Filtro Valores</p>
            </Col>

            <Col className='col-6' >
                {
                    data !== null && (
                        <p>{data.filtro_valores}</p>
                    )
                }
                
            </Col>
        </Row>

        <Row>
            <Col className='col-3' >
                <p>Cuenta</p>
            </Col>


        </Row>

        <Row>
            <Col className='col-3' >
                <p>Impuesto</p>
            </Col>


            <Col className='col-3'>

            {
                    data !== null && (
                        
                        <p>{data.impuesto === "1" ? "Si" : "No"}</p>
                    )
                }

                
            </Col>


        </Row>


        <Row>
            <Col className='col-3' >
                <p>Sufijo</p>
            </Col>


            <Col className='col-3'>

                {
                    data !== null && (
                        <p>{data.sufix}</p>
                        
                    )
                }

                
            </Col>


        </Row>

        <Row>
            <Col className='col-3' >
                <p>Rfc</p>
            </Col>


            <Col className='col-3'>
            {
                    data !== null && (
                        
                        <p>{data.rfc === "1" ? "Si" : "No"}</p>
                    )
                }
                
            </Col>


        </Row>



        </Form>

    </>
  )
}
